import { WSButton } from "@wingspanhq/fe-component-library";
import qs from "qs";
import React from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../../../query/hooks/helpers";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { useQueryMemberProfile } from "../../../../../query/users/queries";
import { openInNewTab } from "../../../../../shared/utils/openInNewTab";
import { PATH_BENEFITS_MERIDIO_EXPLORE_PLANS } from "../../../paths";

const MERIDIO_ONBOARD_URL = "https://bnfts.us/wingspan-onboard";

/**
 * Sidebar CTA for the Meridio benefit: either the in-app enrollment flow or
 * Meridio's own onboarding, prefilled with the member's details.
 */
export const MeridioCTA: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();
  const queryFeatureFlags = useQueryFeatureFlags();
  const queryMember = useQueryMemberProfile(userId);

  const member = queryMember.data;

  const searchParams = member
    ? qs.stringify({
        name: {
          first: member.user.profile.firstName,
          last: member.user.profile.lastName
        },
        phoneNumber: member.user.phone.number?.substring(2),
        email: member.user.email,
        wingspanId: member.memberId
      })
    : "";

  return (
    <WSButton.Primary
      fullWidth
      shimmer={queryMember.isLoading || queryFeatureFlags.isLoading}
      onClick={() => {
        if (queryFeatureFlags.data?.meridioInAppEnrollment) {
          history.push(PATH_BENEFITS_MERIDIO_EXPLORE_PLANS);
        } else {
          openInNewTab(`${MERIDIO_ONBOARD_URL}?${searchParams}`);
        }
      }}
    >
      {queryFeatureFlags.data?.meridioInAppEnrollment
        ? "Explore plans"
        : "Get Started!"}
    </WSButton.Primary>
  );
};
